<template>
  <div>
    <el-dialog
      title="考试详情"
      :visible.sync="dialogFormVisible"
      width="700px"
      @close="emitClose"
    >
      <el-form
        :model="dataForm"
        label-position="right"
        ref="formRules"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <el-form-item
          label="考试学员："
          prop="student_id_list"
        >
          <el-link
            type="primary"
            :underline="false"
            @click="studentDialog=true"
          >选择用户</el-link>
          <div class="student-tag">
            <el-tag
              :key="index"
              v-for="(item,index) in students"
              closable
              :disable-transitions="false"
              @close="removeStudents(index)"
            >
              {{item.realname}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item
          label="考试试卷："
          prop="exam_paper_id"
        >
          <el-select
            v-model="dataForm.exam_paper_id"
            placeholder="请选择考试试卷"
            clearable
          >
            <el-option
              v-for="(item,index) in paperlist"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="阅题人："
          prop="corrector"
        >
          <el-select
            v-model="dataForm.corrector"
            placeholder="请输入手机号搜索学长信息"
            clearable
            filterable
            remote
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="(item,index) in $store.state.seniorList"
              :key="index"
              :label="item.realname"
              :value="item.id"
            >
              <span>{{ `${item.realname}/${item.mobile}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="考试时间："
          prop="exam_time"
        >
          <el-date-picker
            v-model="dataForm.exam_time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="timestamp"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="上传答题："
          prop="content_answer"
        >
          <el-upload
            :action="imgUploadUrl"
            multiple
            :on-success="handleFileSuccess"
            :limit="1"
            :file-list="fileList"
            accept=".png,.jpg,.jpeg,.pdf,.doc,.xlsx,.zip,.xls,.docx,.pptx,.ppt,"
          >
            <el-button
              slot="trigger"
              size="small"
              type="primary"
            >点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="emitClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submit('formRules')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <StudentChoose
      :visible="studentDialog"
      :content="students"
      @close="studentDialog=false"
      @submit="chooseStudent"
    />
  </div>
</template>

<script>




import StudentChoose from "@/components/DialogComponents/Service/StudentChoose.vue";
import { imgUploadUrl, fileUploadUrl } from "@/request/http";
import { mockexamprocessCreate, mockexampaperlist } from "@/request/api";

export default {
  components: {
    StudentChoose
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {},
      dialogFormVisible: this.isVisible,
      fileList: [],
      rules: {
        exam_time: [{ required: true, message: "请选择考试时间", trigger: "blur" }],
        exam_paper_id: [{ required: true, message: "请选择考试试卷", trigger: "change" }],
        corrector: [{ required: true, message: "请选择阅卷人", trigger: "blur" }],
        student_id_list: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.students.length) {
              callback(new Error('请选择发放学员'))
            } else {
              callback()
            }
          },
        }],
        content_answer: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.fileList.length) {
              callback(new Error('请上传答题'))
            } else {
              callback()
            }
          },
        }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      studentDialog: false,
      students: [],
      paperlist: [],
      imgUploadUrl: imgUploadUrl(),
      loading: false,

    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchPaperList()
      }
    },
  },
  methods: {
    fetchPaperList() {
      mockexampaperlist({ isPaging: 1, check_status: 1 }).then((res) => {
        this.paperlist = res.data.list
      });
    },
    emitClose() {
      this.$emit("close");
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            student_id_list: this.students.map(v => {
              return v.id
            }),
            start_exam_time: this.dataForm.exam_time[0],
            end_exam_time: this.dataForm.exam_time[1],
            exam_paper_id: this.dataForm.exam_paper_id,
            corrector: this.dataForm.corrector,
            content_answer: JSON.stringify(this.fileList)
          }
          mockexamprocessCreate(query).then((res) => {
            this.$message.success('提交成功')
            this.$emit('submit')
            this.emitClose()
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    chooseStudent({ data }) {
      this.students = data
    },
    removeStudents(index) {
      this.students.splice(index, 1)
    },
    remoteMethod(query) {
      let reg = /^(-|\+)?\d+$/
      if (reg.test(query)) {
        this.$store.dispatch('fetchAdminSeniorList', { mobile: query })
      } else {
        this.$message.error('请输入完整的手机号')
      }
      /*   if (query != "") {
          this.$store.dispatch('fetchAdminSeniorList', { mobile: query })
        } */
    },
    handleFileSuccess(response, file, fileList) {
      this.fileList.push({
        name: file.raw.name,
        url: response.data.url,
      })
    },
  },
};
</script>

<style lang="less" scoped>
.el-input,
.el-select {
  width: 100%;
}
.upload-demo {
  overflow: hidden;
  height: 35px;
}
.file-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .file-item {
    & + .file-item {
      margin-top: 16px;
    }
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .btn {
        width: 56px;
        height: 24px;
        border: 1px solid #dcdfe6;
        border-radius: 20px;
        color: #606266;
        font-size: 12px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      img {
        width: 16px;
        height: 16px;
        margin-left: 16px;
      }
    }
  }
}
</style>